import React, {useEffect, useState} from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import {Link} from "react-router-dom";

function PrivacyPolicy() {
    const [markdown, setMarkdown] = useState<string>("Loading...");

    useEffect(() => {
        fetch("./privacy-policy.md")
            .then((res) => res.text())
            .then(setMarkdown)
            .catch(() => setMarkdown("Failed to load privacy policy."));
    }, []);

    return (
        <div style={{display: "flex", justifyContent: "center", padding: 50}}>
            <div style={{display: "flex", justifyContent: "center", padding: 50, backgroundColor: 'var(--overlay-color)', borderRadius: 20, boxShadow: '5px 5px 5px #0004'}}>
                <div className="p-4" style={{color: 'white', maxWidth: '1200px'}}>
                    <Link style={{color: 'white'}} to="/">Back to Home</Link>
                    <ReactMarkdown remarkPlugins={[remarkGfm]}>{markdown}</ReactMarkdown>
                </div>
            </div>
        </div>
    );
}

export default PrivacyPolicy;